var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4583 26H1.54167C0.690667 26 0 26.672 0 27.5C0 28.328 0.690667 29 1.54167 29H35.4583C36.3093 29 37 28.328 37 27.5C37 26.672 36.3093 26 35.4583 26Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 0H14.5C13.672 0 13 0.672 13 1.5C13 2.328 13.672 3 14.5 3H35.5C36.328 3 37 2.328 37 1.5C37 0.672 36.328 0 35.5 0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4583 9H1.54167C0.690667 9 0 9.672 0 10.5C0 11.328 0.690667 12 1.54167 12H35.4583C36.3093 12 37 11.328 37 10.5C37 9.672 36.3093 9 35.4583 9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 18H14.5C13.672 18 13 18.672 13 19.5C13 20.328 13.672 21 14.5 21H35.5C36.328 21 37 20.328 37 19.5C37 18.672 36.328 18 35.5 18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon_menu.461b7dd082c2f6d01ba21b32bd7ca291.svg";
export { ForwardRef as ReactComponent };